import {Container, Graphics, Point, Text, loader, extras} from 'pixi.js';
import { isNullOrUndefined } from 'util';

const RANK_SCREEN = new Graphics();
RANK_SCREEN.beginFill(0xECB7C5);
RANK_SCREEN.drawRect(0, 0, 700, 500);
RANK_SCREEN.endFill();
RANK_SCREEN.position.x = 50;
RANK_SCREEN.position.y = 50;

class Highscore extends Container {

    constructor () {
        super();

        this.refresh();
        this.interactive = true;
        this.rankScreen = RANK_SCREEN;
        this.rankScreen.visible = true;
        this.visible = false;
        this.postSent = false;

        this.addChild(this.rankScreen);

        var div = document.createElement("div");
        div.style.position = "absolute";
        div.style.zIndex = "1000";
        div.style.top = "0px";
        div.style.left = "0px";
        div.style.width = "87%";
        div.style.height = "84%";
        div.style.marginLeft = "6.5%";
        div.style.marginRight = "6.5%";
        div.style.marginTop = "6%";
        div.style.marginBottom = "6%";
        div.style.color = "white";
        this.div = div;
    }

    refresh() {
        this.getJSON('https://uratujtecze.pl/game/score.php?type=all',
        (err, data) => {
          if (err !== null) {
            
          } else {
            this.all = data;
            this.refreshTable();
          }
        });

        this.getJSON('https://uratujtecze.pl/game/score.php?type=today',
         (err, data) => {
          if (err !== null) {
            
          } else {
            this.today = data;
            this.refreshTable();
          }
        });
    }

    getJSON(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'json';
        xhr.onload = function() {
          var status = xhr.status;
          if (status === 200) {
            callback(null, xhr.response);
          } else {
            callback(status, xhr.response);
          }
        };
        xhr.send();
    };

    post(nick,score) {
      if (this.postSent === false) {
        if (isNullOrUndefined(score)) {
          score = 0;
        }
        if (isNullOrUndefined(nick)) {
          nick = "Motorniczy";
        }
        nick = nick.replace(/[^\x00-\x7F]/g, "");
        var xhr = new XMLHttpRequest();
        var url = "https://uratujtecze.pl/game/score.php?name=" + nick + "&value=" + score + "&hash=" + btoa("{\"name\":\""+nick.replace(/[^\x00-\x7F]/g, "")+"\",\"value\":" +score+ "}");
        xhr.open('POST', url, true);
        xhr.responseType = 'json';
        xhr.send();
        this.postSent = true;
        return true;
      } else {
        return false;
      }
  };

    show() {
      this.refresh();
      document.body.appendChild(this.div);
    }
    hide() {
      document.body.removeChild(this.div);
    }

    refreshTable() {
      if (isNullOrUndefined(this.today) || isNullOrUndefined(this.all))
        return;

      var divLeft = document.createElement("div");
      divLeft.className = "tab left";
      var tableAll = document.createElement('table');
      var tr = document.createElement('tr');   

      var td1 = document.createElement('th');
      var td2 = document.createElement('th');
      var td3 = document.createElement('th');

      var text1 = document.createTextNode("");
      var text2 = document.createTextNode("Nick");
      var text3 = document.createTextNode("Punkty");

      td1.appendChild(text1);
      td2.appendChild(text2);
      td3.appendChild(text3);
      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);

      tableAll.appendChild(tr);

      for (let i = 0; i < this.all.length; i++) {
        const row = this.all[i];
        var tr = document.createElement('tr');   

          var td1 = document.createElement('td');
          var td2 = document.createElement('td');
          var td3 = document.createElement('td');

          var text1 = document.createTextNode(i+1);
          var text2 = document.createTextNode(row['name']);
          var text3 = document.createTextNode(row['value']);

          td1.appendChild(text1);
          td2.appendChild(text2);
          td3.appendChild(text3);
          tr.appendChild(td1);
          tr.appendChild(td2);
          tr.appendChild(td3);

          tableAll.appendChild(tr);
      }

      var pTitle = document.createElement("p");
      pTitle.innerHTML = "Ranking wszechczasów";
      divLeft.appendChild(pTitle);
      divLeft.appendChild(tableAll);

      var divRight = document.createElement("div");
      divRight.className = "tab right";

      var tableDay = document.createElement('table');
      var tr = document.createElement('tr');   

      var td1 = document.createElement('th');
      var td2 = document.createElement('th');
      var td3 = document.createElement('th');

      var text1 = document.createTextNode("");
      var text2 = document.createTextNode("Nick");
      var text3 = document.createTextNode("Punkty");

      td1.appendChild(text1);
      td2.appendChild(text2);
      td3.appendChild(text3);
      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);

      tableDay.appendChild(tr);

      for (let i = 0; i < this.today.length; i++) {
        const row = this.today[i];
        var tr = document.createElement('tr');   

          var td1 = document.createElement('td');
          var td2 = document.createElement('td');
          var td3 = document.createElement('td');

          var text1 = document.createTextNode(i+1);
          var text2 = document.createTextNode(row['name']);
          var text3 = document.createTextNode(row['value']);

          td1.appendChild(text1);
          td2.appendChild(text2);
          td3.appendChild(text3);
          tr.appendChild(td1);
          tr.appendChild(td2);
          tr.appendChild(td3);

          tableDay.appendChild(tr);
      }

      var pTitle = document.createElement("p");
      pTitle.innerHTML = "Ranking dzienny";
      divRight.appendChild(pTitle);
      divRight.appendChild(tableDay);

      while (this.div.firstChild) {
        this.div.removeChild(this.div.firstChild);
    }
      this.div.appendChild(divLeft);
      this.div.appendChild(divRight);

    }

  } export default Highscore;


// WEBPACK FOOTER //
// ./src/modules/Highscore.js